'use strict'

/**
 * @desc turns arguments into an array, used as a util, for opt
 *
 * @since 3.0.0
 * @return {Array<Arguments>}
 *
 * @see https://github.com/aretecode/awesome-deopt
 * @see https://github.com/petkaantonov/bluebird/wiki/Optimization-killers
 *
 * @example
 *
 *    function eh() {
 *      const args = argumentor.apply(null, arguments).slice(1)
 *
 *      console.log(args)
 *      //=> [1, 10, 100]
 *    }
 *    eh(0, 1, 10, 100)
 *
 */
module.exports = function() {
  var arguments$1 = arguments;

  var len = arguments.length
  var args = new Array(len)
  for (var i = 0; i < len; ++i) { args[i] = arguments$1[i] }
  return args
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJndW1lbnRvci5qcyIsInNvdXJjZXMiOlsiYXJndW1lbnRvci5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIHN0cmljdCdcblxuLyoqXG4gKiBAZGVzYyB0dXJucyBhcmd1bWVudHMgaW50byBhbiBhcnJheSwgdXNlZCBhcyBhIHV0aWwsIGZvciBvcHRcbiAqXG4gKiBAc2luY2UgMy4wLjBcbiAqIEByZXR1cm4ge0FycmF5PEFyZ3VtZW50cz59XG4gKlxuICogQHNlZSBodHRwczovL2dpdGh1Yi5jb20vYXJldGVjb2RlL2F3ZXNvbWUtZGVvcHRcbiAqIEBzZWUgaHR0cHM6Ly9naXRodWIuY29tL3BldGthYW50b25vdi9ibHVlYmlyZC93aWtpL09wdGltaXphdGlvbi1raWxsZXJzXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiAgICBmdW5jdGlvbiBlaCgpIHtcbiAqICAgICAgY29uc3QgYXJncyA9IGFyZ3VtZW50b3IuYXBwbHkobnVsbCwgYXJndW1lbnRzKS5zbGljZSgxKVxuICpcbiAqICAgICAgY29uc29sZS5sb2coYXJncylcbiAqICAgICAgLy89PiBbMSwgMTAsIDEwMF1cbiAqICAgIH1cbiAqICAgIGVoKDAsIDEsIDEwLCAxMDApXG4gKlxuICovXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKCkge1xuICBjb25zdCBsZW4gPSBhcmd1bWVudHMubGVuZ3RoXG4gIGNvbnN0IGFyZ3MgPSBuZXcgQXJyYXkobGVuKVxuICBmb3IgKGxldCBpID0gMDsgaSA8IGxlbjsgKytpKSBhcmdzW2ldID0gYXJndW1lbnRzW2ldXG4gIHJldHVybiBhcmdzXG59XG4iXSwibmFtZXMiOlsiY29uc3QiLCJsZXQiLCJhcmd1bWVudHMiXSwibWFwcGluZ3MiOiJBQUFBLFlBQVk7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFzQlosTUFBTSxDQUFDLE9BQU8sR0FBRyxXQUFXLENBQUM7O0FBQUE7RUFDM0JBLEdBQUssQ0FBQyxHQUFHLEdBQUcsU0FBUyxDQUFDLE1BQU07RUFDNUJBLEdBQUssQ0FBQyxJQUFJLEdBQUcsSUFBSSxLQUFLLENBQUMsR0FBRyxDQUFDO0VBQzNCLEtBQUtDLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxHQUFHLEVBQUUsRUFBRSxDQUFDLEVBQUUsRUFBQSxJQUFJLENBQUMsQ0FBQyxDQUFDLEdBQUdDLFdBQVMsQ0FBQyxDQUFDLENBQUMsRUFBQTtFQUNwRCxPQUFPLElBQUk7Q0FDWjsifQ==